import {checkLabelValueObject} from '../../utils/checkObjects';

/**
 * A class representing an account.
 */
export class Account {
    /**
     * Create an Account.
     * @param {LabelValue} itemCategory - Item Category
     * @param {LabelValue} glNumber - The glNumber value.
     * @param {LabelValue} accountType - The accountType value.
     * @param {LabelValue} wbs - The wbs value.
     * @param {LabelValue} costCenter - The cost center value.
     * @param {LabelValue} profitCenter - The profit center value.
     * @param {number} allocateFor - The allocateFor value.
     * @param {string} allocationType - The allocationType value.
     * @param {string} accountStatus - The accountStatus value.
     * @param {string} consumptionLevel - The consumptionLevel value.
     * @param {boolean} isFixed - The isFixed value.
     */
    constructor(
        itemCategory,
        glNumber,
        accountType,
        wbs,
        costCenter,
        profitCenter,
        allocateFor,
        allocationType,
        accountStatus,
        consumptionLevel,
        isFixed = false,
    ) {
        this._itemCategory = itemCategory;
        this._glNumber = glNumber;
        this._accountType = accountType;
        this._wbs = wbs;
        this._costCenter = costCenter;
        this._profitCenter = profitCenter;
        this._allocateFor = allocateFor;
        this._allocationType = allocationType;
        this._accountStatus = accountStatus;
        this._consumptionLevel = consumptionLevel;
        this._isFixed = isFixed;
    }

    /**
     * Get an JS object containing all the information about the account
     * @return {{accountStatus: string, consumptionLevel: string, itemCategory: LabelValue, costCenter: LabelValue, accountType: LabelValue, glNumber: LabelValue, wbs: LabelValue, allocateFor: number, profitCenter: LabelValue, allocationType: string}}
     */
    getAccount() {
        return {
            itemCategory: checkLabelValueObject(this._itemCategory),
            glNumber: checkLabelValueObject(this._glNumber),
            accountType: checkLabelValueObject(this._accountType),
            wbs: checkLabelValueObject(this._wbs),
            costCenter: checkLabelValueObject(this._costCenter),
            profitCenter: checkLabelValueObject(this._profitCenter),
            allocateFor: this._allocateFor,
            allocationType: this._allocationType,
            accountStatus: this._accountStatus,
            consumptionLevel: this._consumptionLevel,
            isFixed: this._isFixed,
        };
    }

    /**
     * Get the itemCategory value.
     * @return {LabelValue} The itemCategory value.
     */
    get itemCategory() {
        return this._itemCategory;
    }

    /**
     * Set the itemCategory value.
     * @param {LabelValue} value to set
     */
    set itemCategory(value) {
        this._itemCategory = value;
    }

    /**
     * Get the glNumber value.
     * @return {LabelValue} The glNumber value.
     */
    get glNumber() {
        return this._glNumber;
    }

    /**
     * Set the glNumber value.
     * @param {LabelValue} value to set
     */
    set glNumber(value) {
        this._glNumber = value;
    }

    /**
     * Get the accountType value.
     * @return {LabelValue} The accountType value.
     */
    get accountType() {
        return this._accountType;
    }

    /**
     * Set the accountType value.
     * @param {LabelValue} value to set
     */
    set accountType(value) {
        this._accountType = value;
    }

    /**
     * Get the wbs value.
     * @return {LabelValue} The wbs value.
     */
    get wbs() {
        return this._wbs;
    }

    /**
     * Set the wbs value.
     * @param {LabelValue} value to set
     */
    set wbs(value) {
        this._wbs = value;
    }

    /**
     * Get the costCenter value.
     * @return {LabelValue} The costCenter value.
     */
    get costCenter() {
        return this._costCenter;
    }

    /**
     * Set the costCenter value.
     * @param {LabelValue} value to set
     */
    set costCenter(value) {
        this._costCenter = value;
    }

    /**
     * Get the profitCenter value.
     * @return {LabelValue} The profitCenter value.
     */
    get profitCenter() {
        return this._profitCenter;
    }

    /**
     * Set the profitCenter value.
     * @param {LabelValue} value to set
     */
    set profitCenter(value) {
        this._profitCenter = value;
    }

    /**
     * Get the allocateFor value.
     * @return {number} The allocateFor value.
     */
    get allocateFor() {
        return this._allocateFor;
    }

    /**
     * Set the allocateFor value.
     * @param {number} value to set
     */
    set allocateFor(value) {
        this._allocateFor = value;
    }

    /**
     * Get the accountStatus value.
     * @return {string} The accountStatus value.
     */
    get accountStatus() {
        return this._accountStatus;
    }

    /**
     * Set the allocationType value.
     * @param {string} value to set
     */
    set allocationType(value) {
        this._allocationType = value;
    }

    /**
     * Get the allocationType value.
     * @return {string} The allocationType value.
     */
    get allocationType() {
        return this._allocationType;
    }

    /**
     * Set the accountStatus value.
     * @param {string} value to set
     */
    set accountStatus(value) {
        this._accountStatus = value;
    }

    /**
     * Get the consumptionLevel value.
     * @return {string} The consumptionLevel value.
     */
    get consumptionLevel() {
        return this._consumptionLevel;
    }

    /**
     * Set the consumptionLevel value.
     * @param {string} value to set
     */
    set consumptionLevel(value) {
        this._consumptionLevel = value;
    }

    /**
     * Get the isFixed value.
     * @return {boolean} The isFixed value.
     */
    get isFixed() {
        return this._isFixed;
    }

    /**
     * Set the isFixed value.
     * @param {boolean} value to set
     */
    set isFixed(value) {
        this._isFixed = value;
    }
}
